import { type RootState, type AppDispatch, type AppThunk } from "features/Application/globaltypes/redux";
import { createBegin, createFailure, createSuccess } from "../slices/campaignSendSlice";
import DataService from "features/Application/services/dataServices/typedDataService";
import { type CreateCampaignRunPayload } from "../../types/models";
import { EmailSendSessionPeopleTypes } from "enums/emailSendSessionPeopleTypes";
import { type DistributedOpUpdateParams } from "interfaces/updateParams";
import backgroundTask from "features/BackgroundTasks/backgroundTask";

export const createCampaignSend =
  (id: number, payload: CreateCampaignRunPayload): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(createBegin());
    try {
      const updateParams: DistributedOpUpdateParams = {
        id: "CreateCampaignSend",
        title: `Campaign Send`,
        getOperationProps: async () => {
          const result = await DataService.threatDefence.campaigns.createCampaignRun(id, payload);
          return {
            operationId: result.operationId,
            stepsIds: result.stepsIds,
            statusUrl: result.statusUrl,
          };
        },
        successTransientMessage: "Send was successfully created!",
        failureTransientMessage: "Failed to create send!",
      };
      await backgroundTask.initializeDistributedBackgroundTask(updateParams, dispatch);
      dispatch(createSuccess());
    } catch (error) {
      dispatch(createFailure((error as Error).message));
    }
  };

export const createTestCampaignSend =
  (id: number): AppThunk =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      const actorId = getState().userProfile.id;
      const payload = {
        runNow: true,
        isTest: true,
        peopleIds: [
          {
            id: actorId,
            type: EmailSendSessionPeopleTypes.user,
          },
        ],
      };

      const updateParams: DistributedOpUpdateParams = {
        id: "CreateCampaignSend",
        title: `Campaign Test Send`,
        getOperationProps: async () => {
          const result = await DataService.threatDefence.campaigns.createCampaignRun(id, payload);
          return {
            operationId: result.operationId,
            stepsIds: result.stepsIds,
            statusUrl: result.statusUrl,
          };
        },
        successTransientMessage: "Simulated phishing campaign test was successfully sent.",
        failureTransientMessage: "Simulated phishing campaign test could not be sent. Please try again.",
      };
      await backgroundTask.initializeDistributedBackgroundTask(updateParams, dispatch);
    } catch {}
  };
